import Vue from "vue";
import VueRouter from "vue-router";
import guideRoutes from '../views/pages/guide/routes';
import startRoutes from '../views/pages/start/routes';
import simulationRoutes from '../views/pages/simulation/routes';
import problemRoutes from '../views/pages/contract-problem/router';
Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/start'
  },
  {
    path: '/guide',
    ...guideRoutes
  },
  {
    path: '/start',
    ...startRoutes,
  },
  {
    path: '/contract-problem',
    ...problemRoutes
  },
  {
    path: '/simulation',
    ...simulationRoutes
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (to.meta.requiresAuth) {
      if(user == null) {
        next("/start")
      } else {
        next()
      }
  } else {
      next()
  }
})

export default router;
